import React from "react";
import arc_logo from "../../assets/icons/imaging-accreditation/acr.png";
import imaging_acc_1 from "../../assets/icons/imaging-accreditation/imaging-accreditation-01.png";
import imaging_acc_2 from "../../assets/icons/imaging-accreditation/imaging-accreditation-02.png";
import imaging_acc_3 from "../../assets/icons/imaging-accreditation/imaging-accreditation-03.png";
import imaging_acc_4 from "../../assets/icons/imaging-accreditation/imaging-accreditation-04.png";
import imaging_acc_5 from "../../assets/icons/imaging-accreditation/imaging-accreditation-05.png";
import VerifiedIcon from "@mui/icons-material/Verified";
const Certificates = () => {
  return (
    <div className="flex justify-center w-full font-robout lg:py-40 ">
      <div className="w-4/5 flex flex-col gap-8 items-center">
        <div>
          <img src={arc_logo} alt="ACR American College of Radiology" />
        </div>
        <h2 className="lg:text-6xl md:text-5xl text-3xl text-[#d78558] py-10 text-center relative after:content-[''] after:block after:w-48 after:h-[2px] after:bg-[#d78558] after:mt-12 after:mx-auto">
          ACR Accredited Facility
        </h2>
        <p className="text-white text-2xl text-center">
          The Gold Standard in Imaging Accreditation…
        </p>
        <div className="grid lg:grid-cols-5 lg:gap-0 md:gap-4 gap-2 md:grid-cols-3 my-12">
          <div className="p-2">
            <img src={imaging_acc_1} alt="IAC MRI Accreditation" />
          </div>
          <div className="p-2">
            <img src={imaging_acc_2} alt="COMPUTED TOMOGRAPHY ACR AMERICAN COLLEGE OF RADIOLOGY ACCREDITED FACILITY" />
          </div>
          <div className="p-2">
            <img src={imaging_acc_3} alt="MAMMOGRAPHY ACR AMERICAN COLLEGE OF RADIOLOGY LOGY ACCREDITED FACILITY" />
          </div>
          <div className="p-2">
            <img src={imaging_acc_4} alt="NUCLEAR MEDICINE ACR AMERICAN COLLEGE or RADIOLOGY ACCREDITED FACILITY" />
          </div>
          <div className="p-2">
            <img src={imaging_acc_5} alt="POSITRON EMISSION TOMOGRAPHY AMERICAN COLLEGE OF RADIOLOGY ACCREDITED FACILITY" />
          </div>
        </div>
        <div className="flex xl:flex-row flex-col items-center lg:text-left text-center lg:gap-8 lg:mt-12 ">
          <h3 className="text-white xl:w-[45%] text-2xl md:text-4xl lg:text-4xl py-8 2xl:text-5xl leading-10 xl:leading-[3.5rem] w-full  xl:text-[2.75rem]  font-robout font-bold pb-8">
            What is ACR Accreditation
          </h3>
          <div className="xl:w-[55%]  w-full">
            <p className="text-white  xl:text-[1.5rem]  md:text-[1.125rem] text-[1.125rem] leading-normal ">
              Being ACR (American College of Radiology) accredited reflects CDC’s unwavering commitment to excellence. This recognition assures patients that every aspect of care—technology, safety, and expertise—meets the highest nationally recognized standards.
            </p>
             <h3 className="  md:text-3xl text-xl font-robout font-bold py-6 text-white">
              Our facility has undergone a rigorous peer-review evaluation to validate that
            </h3>
            <ul className=" text-left mt-4  xl:text-xl   md:text-xl sm:text-lg text-lg text-white  font-robout">
              <li className="mb-2 flex flex-row gap-4">
                <span className="flex-shrink-0 text-2xl text-[#d78558]">
                  <VerifiedIcon fontSize="30px" />
                </span>
                <span>
                 Imaging is performed with exceptional accuracy and clarity.
                </span>
              </li>
              <li className="mb-2 flex flex-row gap-4">
                <span className="flex-shrink-0 text-2xl text-[#d78558]">
                  <VerifiedIcon fontSize="30px" />
                </span>
                <span>
                Radiologists and technologists are qualified through advanced training and certifications.
                </span>
              </li>
              <li className="mb-2 flex flex-row gap-4">
                <span className="flex-shrink-0 text-2xl text-[#d78558]">
                  <VerifiedIcon fontSize="30px" />
                </span>
                <span>
                 Equipment is maintained at the forefront of global standards, ensuring both safety and precision.
                </span>
              </li>
              <li className="mb-2 flex flex-row gap-4">
                <span className="flex-shrink-0 text-2xl text-[#d78558]">
                  <VerifiedIcon fontSize="30px" />
                </span>
                <span>
                Quality assurance protocols are consistently implemented to uphold reliability and patient safety.
                </span>
              </li>
            </ul>
          </div>
        </div>
        <p className="text-white font-medium xl:text-[1.5rem] md:text-[1.125rem] text-[1.125rem] leading-normal text-center xl:pt-16 lg:pt-12 pt-6 xl:w-3/5 md:w-4/5 w-11/12">
          At CDC, ACR accreditation is not just a badge—it is a promise that every scan is delivered with uncompromising quality, safety, and trust.
        </p>
      </div>
    </div>
  );
};

export default Certificates;
